'use strict';
const angular = require('angular');
/**
 * User Service
 * Provides CRUD operations for application feedback
 * 1. getAllFeedback - get list of all feedback
 * 2. getFeedback - get single feedback
 * 3. createFeedback - create new feedback
 * 4. updateFeedback - update existing feedback
 * 5. deleteFeedback - delete existing feedback
 * 6. addFeedbackTo - add feedback to github or asana
 */


/**
 * Variables
 */

var adminBaseURL; // base url for making requests to admin Feedback API

/*@ngInject*/
export function feedbackServiceService(baseConfigService, $http) {
  adminBaseURL = baseConfigService.getAdminBaseURL();

  // Get list of feedback
  this.getAllFeedback = function () {
      return $http.get(`${adminBaseURL}/feedback`);
  };

  // Get single Feedback
  this.getFeedback = function (id) {
      return $http.get(`${adminBaseURL}/feedback/${id}`);
  };

  // Create new Feedback
  this.createFeedback = function () {
      return $http.post(`${adminBaseURL}/feedback`);
  };
  // Update existing Feedback
  this.updateFeedback = function (id) {
      return $http.post(`${adminBaseURL}/feedback/${id}`);
  };

  // Delete Feedback
  this.deleteFeedback = function (id) {
      return $http.delete(`${adminBaseURL}/feedback/${id}`);
  };

   // Add Feedback to Asana or Github
   this.addFeedbackTo = function (id, type) {
    return $http.post(`${adminBaseURL}/feedback/${type}/${id}`);
};


}

export default angular.module('appApp.feedbackService', [])
  .service('feedbackService', feedbackServiceService)
  .name;



// WEBPACK FOOTER //
// ./client/components/services/feedbackService/feedbackService.service.js